import React from 'react';
import {
  SaveButton,
  CREATE,
  fetchEnd,
  fetchStart,
  showNotification,
  Create,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';
import omit from 'lodash/omit';

import dataProvider from '../../core/providers/IccUserDataProvider';
import { validateFund } from '../funds/creationSteps/utils';
import FundSummary from '../funds/FundSummary';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';
import { getIcError } from '../../core/providers/utils';
import { mapInvestmentStructureToBooleans } from '../funds/InvestmentStructureUtil';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

class FundCreateDialog extends React.Component {
  fundFormProps;

  state = {
    submitting: false
  };

  setFundFormProps = props => {
    this.fundFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.fundFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.fundFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      id,
      refreshView
    } = this.props;

    const { coInvestment, sma } = mapInvestmentStructureToBooleans(
      values.investmentStructure
    );

    const normalizedValues = {
      ...omit(values, ['investmentStructure']),
      dataRoom: Boolean(values.dataRoom),
      coInvestment,
      sma,
      fundBillingAcknowledgement: Boolean(values.acknowledge)
    };

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();
    this.setState({ submitting: true });

    // As we want to know when the new fund has been created in order to close the modal, we use the
    // dataProvider directly
    dataProvider(CREATE, 'funds', { data: normalizedValues })
      .then(({ data }) => {
        //Create fundinvestors relation with the new created fund
        dataProvider(CREATE, 'fundinvestors', {
          data: { fundId: data.id, investorId: id }
        }).then(() => {
          refreshView();
          handleDialogToggle();
        });
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.fundFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const {
      showDialog,
      showNotification,
      fetchStart,
      fetchEnd,
      classes,
      refreshView,
      ...createProps
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`Create new fund`}
        maxWidth="md"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          Create new fund
        </DialogTitleWithCloseButton>
        <DialogContent>
          {/* Override record object that contains investor information */}
          <Create {...createProps} record={{}} className={classes.fullWidth}>
            <SimpleFormWithSave
              toolbar={null}
              resource="funds"
              onSave={this.handleSubmit}
              variant="standard"
              margin="normal"
              validate={validateFund}
            >
              <FormSpy>
                {props => {
                  this.setFundFormProps(props);
                  return <FundSummary creation={true} />;
                }}
              </FormSpy>
            </SimpleFormWithSave>
          </Create>
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label="Create and Add"
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(FundCreateDialog));
